export enum ErrorPriority {
    High,
    Medium,
    Low,
}